import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../';
import { TokenData, TokenDataNew } from './types';

export interface UserState {
  evmAccount: string;
  chain: string;
  wallet: TokenData[];
  tokens: TokenDataNew[];
  change: number;
  solAccount: string
}

const initialState: UserState = {
    evmAccount: "",
    chain: "",
    wallet: [],
    tokens: [],
    change: 0,
    solAccount: ""
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
      setEVMAccount: (state: { evmAccount: string; }, action: PayloadAction<string>) => {
        state.evmAccount = action.payload;
      },
      setSolAccount: (state: { solAccount: string; }, action: PayloadAction<string>) => {
        state.solAccount = action.payload;
      },
      setChain: (state: { chain: string; }, action: PayloadAction<string>) => {
        state.chain = action.payload;
      },
      setWallet: (state: { wallet: TokenData[]}, action: PayloadAction<TokenData[]>) => {
        state.wallet = action.payload;
      },
      setTokens: (state: { tokens: TokenDataNew[]}, action: PayloadAction<TokenDataNew[]>) => {
        state.tokens = action.payload;
      },
      setChange: (state: { change: number; }, action: PayloadAction<number>) => {
        state.change = action.payload;
      },
    },
});

export const { setEVMAccount, setSolAccount, setWallet, setChain, setChange, setTokens } = userSlice.actions;

export const selectChain = (state: RootState) => state.user.chain;
export const selectEVMAccount = (state: RootState) => state.user.evmAccount;
export const selectWallet = (state: RootState) => state.user.wallet;
export const selectChange = (state: RootState) => state.user.change;
export const selectSolAccount = (state: RootState) => state.user.solAccount;
export const selectTokens = (state: RootState) => state.user.tokens;

export default userSlice.reducer;